import { Component } from 'react'
import ReactDOM from 'react-dom'
import Button from '../../Nodes/Button'
import { Overline } from '../../Nodes/Typography'

class Snackbar extends Component {
    hiddenClass = 'snackbar--hidden'

    state = { timeoutKey: undefined }

    static defaultProps = {
        timeout: 4000
    }

    constructor(props) {
        super(props)
        this.containerEl = document.createElement('div')
        this.containerEl.classList.add('snackbar')
        this.containerEl.classList.add(this.hiddenClass)
    }

    renderSnackbar = () => {
        const { children, onClose } = this.props

        return (
            <div className="snackbar__content">
                <Overline className="snackbar__message">{children}</Overline>
                <Button className="snackbar__btn" onClick={onClose}>Dismiss</Button>
            </div>
        )
    }

    render() {
        const { open } = this.props

        open ? 
            this.containerEl.classList.remove(this.hiddenClass) :
            this.containerEl.classList.add(this.hiddenClass)

        return ReactDOM.createPortal(
            this.renderSnackbar(),
            this.containerEl)
    }

    componentDidMount() {
        document.body.appendChild(this.containerEl)
    }

    componentWillUnmount() {
        document.body.removeChild(this.containerEl)
    }

    componentDidUpdate() {
        const { open, onClose, timeout } = this.props

        if (open && !this.state.timeoutKey) {
            const timeoutKey = window && window.setTimeout(() => {
                onClose()
                this.setState({ timeoutKey: undefined })
            }, timeout)
            this.setState({ timeoutKey })
        }
    }
}

export default Snackbar